import React from "react"
import Grid from "@mui/material/Grid2";
import {CircularProgress, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const MoveInProgress = () => {
    const { t } = useTranslation()

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid className="pageMainHeader">
            </Grid>
            <Grid justifyItems="center" className="contentWithMargin">
                <Typography variant="subtitle1" gutterBottom>
                    {t('selfService.goingToWorkQueue')}
                </Typography>
                <CircularProgress color="primary" size={48}/>
            </Grid>
            <Grid/>
            <Grid>
            </Grid>
        </Grid>
    )
}

export default MoveInProgress